<template>
    <el-dialog :visible.sync="visible" @close="handleClose" :show-close="false" class="ah-dialog no-header small center" append-to-body>
        <img class="dialog-img square" src="@/assets/img/dialog/logout.jpg" />
        <div class="content">
            <div class="inner-title">繼續使用嗎？</div>
            <div>
                系統將在 <span style="color: black; font-weight: bold;">{{ Math.ceil(this.timeLeft / 1000) }}</span> 秒後自動登出。
            </div>
            <div class="actions vertical narrow">
                <el-button type="primary" @click="handleClose(false)">繼續使用</el-button>
                <el-button type="" @click="handleClose(true)">登出</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'logout-warning-dialog',
    props: ['visible', 'timeLeft'],
    data() {
        return {};
    },
    created() {},
    methods: {
        handleClose(isLogout) {
            this.$emit('close', isLogout);
        },
    },
};
</script>
